import { CmsFooter, CmsHeader, CmsSeoSite } from '@domgen/dgx-fe-cms';

export interface CmsSelfFixRoot extends CmsHeader, CmsFooter, CmsSeoSite {}
